// extracted by mini-css-extract-plugin
module.exports = {"card-link":"VendorProductCard_card-link__NFIlg"};